import sendBasketReq from './helpers/basketFetch';

const changeRangeInputStyle = (rangeInputElem, minValue, maxValue, currentValue) => {
  rangeInputElem.style.backgroundSize = `${((currentValue - minValue) * 100) / (maxValue - minValue)}% 100%`;
};
let timeOut = null;
let basicInputTimeout = null;
const changeScore = (score) => {
  clearTimeout(timeOut);
  timeOut = setTimeout(async () => {
    const data = {
      fullRecalculation: 'Y',
      partnerScore: score,
    };

    const formData = new FormData();
    const dataKeys = Object.keys(data);

    for (let i = 0; i < dataKeys.length; i++) {
      formData.append(dataKeys[i], data[dataKeys[i]]);
    }

    const response = await sendBasketReq(formData);
    if (response) {
      const html = document.createElement('div');
      html.innerHTML = response;
      const basketContainer = document.querySelector('#basket-container');
      if (basketContainer) {
        basketContainer.innerHTML = html.querySelector('#basket-container').innerHTML;
        window.cartInit();
      }
    }
  }, 1000);
};

const rangeInputHandler = (evt) => {
  evt.preventDefault();

  changeRangeInputStyle(
    evt.target,
    evt.target.min,
    evt.target.max,
    evt.target.value,
  );

  const basicInput = document.querySelector('[data-input-type="jsPointsInput"]');
  const pointsValueBlock = document.querySelector('[data-points-value="jsPointsValue"]');

  basicInput.value = evt.target.value;

  const total = `${(evt.target.value ? evt.target.value : 0) * evt.target.dataset.pointsRate}`;
  pointsValueBlock.innerHTML = `${total}${total.includes('.') ? '' : '.00'} ₽`;
};

const changeScoreHandler = (evt) => {
  changeScore(evt.target.value ? evt.target.value : 0);
};

const basicInputHandler = (evt) => {
  clearTimeout(basicInputTimeout);
  evt.preventDefault();
  basicInputTimeout = setTimeout(() => {
    const rangeInput = document.querySelector('[data-input-type="jsPointsRange"]');
    const pointsValueBlock = document.querySelector('[data-points-value="jsPointsValue"]');
    const maxValue = evt.target.dataset.maxValue;

    if (+evt.target.value > +maxValue) evt.target.value = +maxValue;
    else if (evt.target.value && +evt.target.value === 0 && evt.target.value.length > 1) {
      evt.target.value = 0;
      return;
    }
    rangeInput.value = +evt.target.value;

    const minRangeValue = rangeInput.min;
    const maxRangeValue = rangeInput.max;
    const currentRangeValue = rangeInput.value;
    changeRangeInputStyle(
      rangeInput,
      minRangeValue,
      maxRangeValue,
      currentRangeValue,
    );

    const total = `${(evt.target.value ? evt.target.value : 0) * evt.target.dataset.pointsRate}`;
    pointsValueBlock.innerHTML = `${total}${total.includes('.') ? '' : '.00'} ₽`;
    if (evt.target.value) {
      changeScore(evt.target.value ? Math.floor(evt.target.value) : 0);
    }
  }, 500);
};

const pointsIinputsInit = () => {
  const rangeInput = document.querySelector('[data-input-type="jsPointsRange"]');
  const basicInput = document.querySelector('[data-input-type="jsPointsInput"]');

  if (!rangeInput || !basicInput) return;

  rangeInput.addEventListener('input', rangeInputHandler);
  rangeInput.addEventListener('mouseup', changeScoreHandler);
  const minRangeValue = rangeInput.min;
  const maxRangeValue = rangeInput.max;
  const currentRangeValue = rangeInput.value;
  changeRangeInputStyle(
    rangeInput,
    minRangeValue,
    maxRangeValue,
    currentRangeValue,
  );
  rangeInput.classList.add('_init');

  basicInput.addEventListener('input', basicInputHandler);
  basicInput.classList.add('_init');
};
const basketUpdateTotalDataHandler = (totalData) => {
  const partnerSpollers = document.querySelector('._partner_spollers');
  if (totalData.IS_PARTNER && totalData.MAX_SCORE > 0) {
    partnerSpollers.style.display = 'block';
    const discountAll = document.querySelector('.discount_all');
    const discountPartnerScore = document.querySelector('.discount_partner_score');
    const couponSpollers = document.querySelector('._coupon-spollers');
    let partnerSpollersTitle = null;
    let partnerSpollersBody = null;
    let rangeInput = null;
    let pointInput = null;
    if (partnerSpollers) {
      partnerSpollersTitle = partnerSpollers.querySelector('.side-cart__sales-title');
      partnerSpollersBody = partnerSpollers.querySelector('.side-cart__sales-body');
      rangeInput = partnerSpollers.querySelector('.side-cart__sales-points-range');
      pointInput = partnerSpollers.querySelector('.side-cart__sales-points-input');
    }
    if (totalData.PARTNER_SCORE > 0) {
      if (discountAll) discountAll.classList.add('hidden');
      if (discountPartnerScore) {
        discountPartnerScore.classList.remove('hidden');
        discountPartnerScore.querySelector('[data-entity="basket-total-points"]').innerHTML = `-${totalData.DISCOUNT_PRICE_FORMATED}`;
      }
      if (couponSpollers) couponSpollers.classList.add('disable_coupon');
      if (partnerSpollersTitle) partnerSpollersTitle.classList.add('_active');
      if (partnerSpollersBody) {
        partnerSpollersBody.classList.add('_active');
        partnerSpollersBody.querySelector('[data-points-value="jsPointsValue"]').innerHTML = totalData.DISCOUNT_PRICE_FORMATED;
      }
    } else {
      if (discountAll) discountAll.classList.remove('hidden');
      if (discountPartnerScore) discountPartnerScore.classList.add('hidden');
      if (couponSpollers) couponSpollers.classList.remove('disable_coupon');
      if (partnerSpollersTitle) partnerSpollersTitle.classList.add('_active');
      if (partnerSpollersBody) partnerSpollersBody.classList.add('_active');
    }
    if (rangeInput) {
      rangeInput.value = totalData.PARTNER_SCORE;
      rangeInput.setAttribute('max', totalData.MAX_SCORE);
      rangeInput.dataset.pointsRate = totalData.RATE;
    }
    if (pointInput) pointInput.value = totalData.PARTNER_SCORE;
    if (partnerSpollersBody) partnerSpollersBody.querySelectorAll('[data-entity="max-score"]').forEach((el) => { el.innerText = totalData.MAX_SCORE; });
    if (partnerSpollersBody) partnerSpollersBody.querySelectorAll('[data-entity="min-score"]').forEach((el) => { el.innerText = totalData.MIN_SCORE; });
    if (partnerSpollersBody) partnerSpollersBody.querySelectorAll('[data-entity="max-score-format"]').forEach((el) => { el.innerText = totalData.MAX_SCORE_FORMAT; });

    if (totalData.MIN_SCORE > totalData.MAX_SCORE) {
      partnerSpollers.style.display = 'none';
      document.querySelector('.side-cart__warning-block').style.display = 'block';
    } else {
      partnerSpollers.style.display = 'block';
      document.querySelector('.side-cart__warning-block').style.display = 'none';
    }
  } else if (partnerSpollers) {
    partnerSpollers.style.display = 'none';
  }

  pointsIinputsInit();
};
window.basketUpdateTotalDataHandler = basketUpdateTotalDataHandler;

pointsIinputsInit();
window.pointsIinputsInit = pointsIinputsInit;
